<ng-template #bankLoanCheckboxTemplate>
    <div class="card h-100 w-100 mt-2">
        <div
            class="card-header card-cs-checkbox"
            [ngClass]="{'checked': isSimulateBankLoanChecked}"
        >
            <div class="row d-flex justify-content-between">
                <div class="col d-flex align-items-center">
                    <stCheckbox
                        innerId="simulate-bank-loan"
                        labelClass="d-flex align-items-center"
                        inputClass="p-2"
                        [(ngModel)]="isSimulateBankLoanChecked"
                        [trueValue]="true"
                        [falseValue]="false"
                    >
                        <span class="px-2"> Je simule un emprunt bancaire </span>
                    </stCheckbox>
                </div>
                <div class="col-auto d-flex align-items-center">
                    <stButton
                        class="btn-info-modal"
                        btnClass="d-flex align-items-center py-0"
                        iconLeft="bi bi-info-circle-fill text-st-secondary fs-5"
                        iconLeftHover="bi bi-info-circle fs-5"
                        (onClick)="solarService.openBankLoanInfoModal()"
                        title="Plus d'information"
                    ></stButton>
                </div>
            </div>
        </div>
    </div>
</ng-template>

@if (solarService.simulationBankLoanObs$ | async) {
<cadastreSolaireBankLoan
    class="flex-grow-1 overflow-auto"
    [investment]="currentResult.netInvestment"
    [gain]="currentResult.saving"
    [roi]="currentResult.originalRoi"
    [bonus]="currentResult.help"
>
</cadastreSolaireBankLoan>
} @else{
<div class="d-flex flex-column h-100">
    <div class="flex-grow-1 overflow-auto">
        <div class="w-100 p-3">
            <div class="header mb-3">
                <div class="container-fluid">
                    <div class="row d-flex align-items-center solar-card">
                        <div class="col-auto px-0 text-center">
                            <span class="fa-stack">
                                <i class="fa fa-circle-thin fa-stack-2x"></i>
                                <i class="fa fa-info fa-stack-1x"></i>
                            </span>
                        </div>
                        <div class="col">
                            <p>
                                Un projet solaire thermique nécessite d'adapter la taille de
                                l'installation à votre consommation.
                            </p>
                            @if (optimalResult ) {
                            <p>
                                Pour le nombre d’occupant renseigné nous estimons que l'installation
                                la plus rentable est de {{ optimalResult.stringifiedModuleCount }}
                                {{ optimalResult.moduleCount == 1 ? 'panneau' : 'panneaux' }}.
                                <!-- , soit {{ optimalResult.stringifiedPeakPower }}&nbsp;kWc. -->
                            </p>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div class="body">
                <div class="my-2 solar-loader-icon" [hidden]="!showLoader">
                    <div>
                        <i class="fa fa-spinner fa-pulse fa-4x fa-fw"></i>
                    </div>
                    <div>
                        Simulation de votre <br />
                        projet en cours
                    </div>
                </div>

                <div [hidden]="showLoader" class="result-content">
                    <div class="solar-card slider-container" *ngIf="slider">
                        <div class="content">
                            <h5 class="text-st-primary">{{ adjustInstallationSizeLabel }}</h5>

                            <div class="container-fluid slider">
                                <div class="row">
                                    <!-- <div class="col-4 peak-power">
                                        <div>Puissance</div>
                                        <div class="value">
                                            {{ slider.stringifiedPeakPower }}&nbsp;kWc
                                        </div>
                                    </div> -->
                                    <div class="col panel-count">
                                        <div>Nombre de panneaux</div>
                                        <div class="value">
                                            {{ slider.moduleCount }} {{ slider.moduleCount == 1 ?
                                            'panneau' : 'panneaux' }}
                                        </div>
                                    </div>
                                    <div class="col panel-area">
                                        <div>Surface</div>
                                        <div class="value">{{ slider.moduleArea }} m²</div>
                                    </div>
                                </div>

                                <stRange
                                    innerId="thermal-module-count"
                                    [min]="1"
                                    [max]="slider.maxModuleCount"
                                    [step]="1"
                                    [value]="slider.moduleCount"
                                    [(ngModel)]="slider.moduleCount"
                                    (input)="updateModuleCountByBuilding()"
                                >
                                </stRange>
                            </div>
                        </div>

                        <div
                            [ngbCollapse]="!isOverProductionWarningActive"
                            (ngbCollapseChange)="isOverProductionWarningActive = $event"
                        >
                            <div class="warning-container">
                                <div class="alert">
                                    <i class="bi bi-exclamation-circle fa-2x"></i>
                                    <div>
                                        La production en eau chaude des panneaux est supérieure à
                                        vos besoins estimés. Vous devriez modifier le nombre de
                                        panneaux de votre installation pour éviter qu'elle ne soit
                                        surdimensionnée.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <cadastre-solaire-result-card
                        iconSvg="list_check"
                        [titleLabel]="titleInvestment"
                        [contentHtml]="htmlThInvestment"
                        [modalContentHtml]="tooltipThInvestmentDetail"
                        [modalSize]="'lg'"
                        [extraTemplate]="bankLoanTemplateOrNull"
                    ></cadastre-solaire-result-card>

                    <cadastre-solaire-result-card
                        icon="fa fa-eur fs-3"
                        [titleLabel]="titleEconomy"
                        [contentHtml]="htmlThEconomy"
                        [modalContentHtml]="tooltipThEconomyDetail"
                        [warningMessage]="warningMessageEconomy"
                    ></cadastre-solaire-result-card>

                    <cadastre-solaire-result-card
                        iconSvg="bolt"
                        [titleLabel]="titleProduction"
                        [contentHtml]="htmlThProduction"
                        [modalContentHtml]="tooltipThProductionDetail"
                    ></cadastre-solaire-result-card>

                    <ng-container *ngIf="!modularity.simulations">
                        <ng-container *ngIf="!!htmlThWarning">
                            <div [innerHtml]="htmlThWarning"></div>
                        </ng-container>
                        <ng-container *ngIf="!htmlThWarning">
                            <div class="text-center">
                                <small>
                                    Ces données sont issues d'un traitement automatisé et sont un
                                    premier ordre d'idée. Cela ne remplace pas la visite d'un
                                    technicien agréé.
                                </small>
                            </div>
                        </ng-container>
                    </ng-container>

                    <div *ngIf="modularity.downloadResults && !modularity.simulations">
                        <button
                            type="button"
                            class="btn btn-st-primary solar-pdf"
                            (click)="downloadPdf()"
                            [disabled]="isResultsDownloading"
                        >
                            <span *ngIf="!isResultsDownloading">Télécharger le récapitulatif</span>
                            <i class="fa fa-spinner fa-pulse" *ngIf="isResultsDownloading"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="footer border-top" [hidden]="showLoader">
        <div class="container-fluid py-3">
            <div class="row">
                <div class="col-5">
                    <stButton
                        class="btn-st-lg"
                        btnClass="btn-st-default w-100 h-100"
                        btnLabel="Retour"
                        (onClick)="cancel()"
                    >
                    </stButton>
                </div>
                <div class="col-7">
                    <stButton
                        class="btn-st-lg"
                        btnClass="btn-st-primary w-100"
                        [btnLabel]="mainButtonLabel"
                        (click)="mainButtonAction()"
                    ></stButton>
                </div>
            </div>
        </div>
    </div>
</div>
}
